module.exports = __webpack_public_path__ + "media/img/mcv-og-1200x630-d7a9b458.jpg";